import { render, staticRenderFns } from "./Frontend.vue?vue&type=template&id=63ef7666&scoped=true"
import script from "./Frontend.vue?vue&type=script&lang=js"
export * from "./Frontend.vue?vue&type=script&lang=js"
import style0 from "./Frontend.vue?vue&type=style&index=0&id=63ef7666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ef7666",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
